/**
 * WebSocket contract.
 *
 * Two channels only (DESIGN.md §14):
 *   `global`          — subscribed while any page is open
 *   `screening:{id}`  — subscribed while viewing a screening
 *
 * Every event here has a REST equivalent. The socket is an accelerator, never
 * the only path. On reconnect the client refetches full state rather than
 * replaying missed events — at ~40 users a refetch is a few kilobytes and it
 * deletes an entire category of desync bugs.
 */
export const screeningChannel = (screeningId) => `screening:${screeningId}`;
//# sourceMappingURL=events.js.map